module.exports = __webpack_public_path__ + "assets/img/T8-mz1.c5ad5409.jpg";